import routes from "./_routes";

export default routes ;
